import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { useState, type ReactNode } from 'react';

import { useIsMobile } from '@/hooks/useIsMobile';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel: string;
  destructive?: boolean;
  /** Show an optional free-text note that is stored with the change. */
  withNote?: boolean;
  onCancel: () => void;
  onConfirm: (note: string) => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  destructive = false,
  withNote = false,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  const isMobile = useIsMobile();
  const [note, setNote] = useState('');

  const close = () => {
    setNote('');
    onCancel();
  };

  return (
    // Full screen on a phone: a small centred dialog with a text field in it
    // fights the on-screen keyboard for room.
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth fullScreen={isMobile}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <DialogContentText component="div">{message}</DialogContentText>
          {withNote && (
            <TextField
              label="Notiz (optional)"
              value={note}
              onChange={(event) => setNote(event.target.value)}
              fullWidth
              autoFocus
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Abbrechen</Button>
        <Button
          variant="contained"
          color={destructive ? 'error' : 'primary'}
          onClick={() => {
            onConfirm(note);
            setNote('');
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
